<template>
	<div class="desktop-footer">
		<div class="desktop-footer__inner">
			<div class="desktop-footer__logo">
				<a href="https://www.smuckerawayfromhome.com/brands/jif" target="_blank">
					<img src="https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/jif.png" alt="Jif">
				</a>
			</div>
			<div class="desktop-footer__logo">
				<a href="https://www.smuckerawayfromhome.com/brands/jif" target="_blank">
					<img src="https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome/Campaigns/Jif-Tool/jif-natural.png" alt="Natural Jif">
				</a>
			</div>
			<div class="desktop-footer__fine-print">ⓒ/TM/Ⓡ The J.M. Smucker Company</div>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

@import "../styles/_colors.scss";
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";

.desktop-footer {
	height: 112px;
	position: relative;
	padding: 0.5em 1em 1.5em 1em;
	margin-top: 1em;
	&::after {
		content: '';
		display: block;
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: $transWhite;
		height: 100%;
		z-index: map-get($z, 1);
		clip-path: polygon(0 60%, 100% 0, 100% 100%, 0% 100%);
	}
}

.desktop-footer__inner {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	z-index: map-get($z, 2);
	position: relative;
}

.desktop-footer__logo {
	flex: 0 0 152px;
	margin: -32px 0 0 0;
}

.desktop-footer__fine-print {
	font-family: $slab;
	flex: 1 1 100%;
	width: 100%;
	text-align: center;
	font-size: em(8);
	color: $blue;
}
</style>